import { Injectable } from '@angular/core';
import { AppConsts } from 'shared/AppConsts';
import { environment } from 'environments/environment';


@Injectable()
export class CookieService {

  constructor() {
  }

  setCookieValue = function (key: string, value: string, expireDate?: Date, path?: string, domain?: string): void {
    var cookieValue = encodeURIComponent(key) + '=';

    if (value) {
      cookieValue = cookieValue + encodeURIComponent(value);
    }

    if (expireDate) {
      cookieValue = cookieValue + "; expires=" + expireDate.toUTCString();
    }

    if (path) {
      cookieValue = cookieValue + "; path=" + path;
    }

    document.cookie = cookieValue;
  };
}



// WEBPACK FOOTER //
// ./src/shared/utils/cookie.service.ts